// extracted by mini-css-extract-plugin
export default {"group":"Helpinfo_group__e5hT7"};